// 其他事项管理路由

const itemRouter = {
  path: 'Item',
  name: 'Item',
  component: { render: h => h('router-view') },
  children: [
    {
      path: 'guarantee-detail',
      name: 'guarantee-detail',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'application',
          name: 'application',
          component: () =>
            import(
              /* webpackChunkName: "" */ '@/views/Item/guarantee-detail/application.vue'
            ),
        },
        {
          path: 'application-detail/:companyCode',
          name: 'application-detail',
          component: () =>
            import(
              /* webpackChunkName: "application-detail" */ '@/views/Item/guarantee-detail/application-detail'
            ),
        },
        {
          path: 'guarantee-approval/:id',
          name: 'guarantee-approval',
          meta: {
            title: '担保审批',
          },
          component: () =>
            import(
              /* webpackChunkName: "guarantee-approval" */ '@/views/Item/guarantee-detail/guarantee-approval'
            ),
        },
        {
          path: 'approve',
          name: 'approve',
          component: () =>
            import(
              /* webpackChunkName: "" */ '@/views/Item/guarantee-detail/approve.vue'
            ),
        },
        {
          path: 'query',
          name: 'query',
          component: () =>
            import(
              /* webpackChunkName: "" */ '@/views/Item/guarantee-detail/query.vue'
            ),
        },
        {
          path: 'queryAll',
          name: 'queryAll',
          component: () =>
            import(
              /* webpackChunkName: "" */ '@/views/Item/guarantee-detail/query/queryAll.vue'
            ),
        },
      ],
    },
    {
      path: 'outward-record',
      name: 'outward-record',
      component: () =>
        import(/* webpackChunkName: "" */ '@/views/Item/outward-record'),
    },
    {
      path: 'insurance',
      name: 'insurance',
      component: () =>
        import(/* webpackChunkName: "" */ '@/views/Item/insurance'),
    },
    {
      path: 'item-search',
      name: 'item-search',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'extension-record-search',
          name: 'extension-record-search',
          component: () =>
            import(
              '@/views/Item/item-search/extension-record-search'
            ),
        },
        {
          path: 'batch-extension-search',
          name: 'batch-extension-search',
          component: () =>
            import(
              '@/views/Item/item-search/batch-extension-search'
            ),
        },
        {
          path: 'approve-list-search',
          name: 'approve-list-search',
          component: () =>
            import(
              '@/views/Item/item-search/approve-list-search'
            ),
        },
        {
          path: 'batch-period-search',
          name: 'batch-period-search',
          component: () =>
            import(
              '@/views/Item/item-search/batch-period-search'
            ),
        },
      ],
    },

    {
      path: 'period-batch',
      name: 'period-batch',
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'period-batch-approval-detail/:bpmId',
          name: 'period-batch-approval-detail',
          meta: {
            title: '批量审批详情',
          },
          component: () =>
            import('@/views/Item/period-batch/period-batch-approval-detail'),
        },
        {
          path: 'batch-period-list',
          name: 'batch-period-list',
          component: () =>
            import(
              '@/views/Item/period-batch/batch-period-list'
            ),
        },
        {
          path: 'batch-period-record-list',
          name: 'batch-period-record-list',
          component: () =>
            import(
              '@/views/Item/period-batch/batch-period-record-list'
            ),
        },
      ]
    },
  ],
}

export default itemRouter
